(() => {
  const initialize = () => document.querySelectorAll('[data-pdl-menu-vehicle-tool]').forEach(root => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const load = () => window.pdlVehicleCompatibility.mountQuickSearch(root);
    const panel = root.closest('[data-pdl-submenu]');
    if (!panel) { load(); return; }
    const observer = new MutationObserver(() => { if (!panel.hidden) load(); });
    observer.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
    if (!panel.hidden) load();
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
